import { ReactNode, useMemo } from "react";
import OpacityView from "src/components/OpacityView";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useDim from "src/hooks/useDim";
import { useSafeArea } from "src/swsh-native";

const FullHeightElementWrapper = ({
	children: _children,
	renderChildren,
}: {
	children?: ReactNode;
	renderChildren?: (args: { height: number }) => ReactNode;
}) => {
	const headerHeight = useGatheringStore((state) => state.headerHeight);
	const dim = useDim({
		staticDim: true,
	});
	const safeArea = useSafeArea();
	const height = useMemo(() => {
		return headerHeight ? dim.height - headerHeight - safeArea.bottom : null;
	}, [dim.height, headerHeight, safeArea.bottom]);

	if (!height) return null;
	const children = renderChildren ? renderChildren({ height }) : _children;
	return (
		<OpacityView
			style={{
				height,
				width: "100%",
			}}
		>
			{children}
		</OpacityView>
	);
};
export default FullHeightElementWrapper;
